import { ElementType, ReactNode, HTMLAttributes } from 'react';

export default function Tag({ element, children }: { element?: ElementType<HTMLAttributes<HTMLElement>>, children: ReactNode }) {
  const Element: ElementType<HTMLAttributes<HTMLElement>> = element || 'h2';

  return (
    <Element className="app--calendar__component--tag">
      {children}
    </Element>
  );
}
